import { type ComponentProps } from 'react'
import { tv } from 'tailwind-variants'
import * as v from 'valibot'
import { DecorationBadgeDataSchema } from 'src/features/UserDecoration/schema/decoration'
import type { Decoration } from 'src/services/apollo/generated/graphql'

const badgeTokenStyles = tv({
  slots: {
    root: '',
    ring: 'fill-transparent',
    icon: 'size-full',
  },
  variants: {
    disabled: {
      true: {
        ring: 'stroke-zinc-300 dark:stroke-zinc-600',
        icon: 'grayscale opacity-40',
      },
    },
  },
  compoundVariants: [
    {
      irregular: true,
      disabled: false,
      className: {
        ring: 'mix-blend-multiply',
      },
    },
    { irregular: false, disabled: true, className: { root: 'scale-90' } },
  ],
  defaultVariants: {
    irregular: false,
    disabled: false,
  },
})

export default function UserBadgeToken({
  disabled,
  className,
  style,
  decoration,
  imgProps,
  ...domProps
}: ComponentProps<'div'> & {
  disabled?: boolean
  decoration?: Decoration
  imgProps?: ComponentProps<'img'>
}) {
  const styles = badgeTokenStyles({
    disabled,
  })

  const data = v.safeParse(DecorationBadgeDataSchema, decoration?.data)
  if (!data.success) return null

  const assetUrl = data.output.assetUrl
  if (assetUrl) {
    return (
      <div
        {...domProps}
        className={styles.root({ className })}
        style={{
          height: 'auto',
          ...style,
        }}
      >
        <img src={assetUrl} alt="" {...imgProps} />
      </div>
    )
  }
  return null
}
